import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from './loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  
  // Inicia o loading
  loadingService.show();
  
  return next(req).pipe(
    // Finaliza o loading quando a requisição terminar
    finalize(() => loadingService.hide())
  );
};
